import { useFormContext, useWatch } from 'react-hook-form'

import { Info } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Status = () => {
  const { control } = useFormContext<SarEdit>()
  const status = useWatch({ control, name: 'generalInfo.status' })

  return <Info label="Status">{status}</Info>
}
